import {Component} from '@angular/core';
import {CommonService} from '../../../services/common.service';
import {UserService} from '../../../services/user.service';
import { ImagesService } from '../../../services/images.service';

@Component({
    selector: 'my-clubs',
    templateUrl: 'app.component.html',
    styleUrl: 'app.component.scss',
    standalone: false
})
export class ClubsComponent {
  public clubs;
  public loading: boolean;

  constructor(
    protected userService: UserService,
    public commonService: CommonService,
    private imagesService: ImagesService,
  ) {
    this.loading = true;

    this.userService.getUserClubs().then(({data}) => {
      this.clubs = data;
      this.loading = false;
    });
  }

  public navigate(path) {
    this.commonService.navigate(path);
  }
}
